import "babel-polyfill";
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex';
import vueTap from './components/tap.js';
import Storage from '@/common/js/utils/storage';
import Modal from '@/common/js/modal';
import * as custom from '@/common/filters/custom';
import * as globalCustom from '@/common/global';
import { Picker, Popup, DatetimePicker, Swipe, SwipeItem } from 'mint-ui';
import Vant from 'vant'
// import VueClipboard from 'vue-clipboard2'
import 'vant/lib/index.css'

Vue.component(Popup.name, Popup);
Vue.component(Picker.name, Picker);
Vue.component(DatetimePicker.name, DatetimePicker);
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);

Vue.config.productionTip = false;
Vue.use(vueTap);
Vue.use(Vuex);
Vue.use(Vant)
// Vue.use(VueClipboard);

// import vconsole from 'vconsole'
// console.log('当前环境：', process.env.NODE_ENV)
// if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'stg') {
//     const vc = new vconsole()
//     Vue.use(vc)
// }

// 注册过滤器
Object.keys(custom).forEach(key => {
    Vue.filter(key, custom[key]);
});

// 全局方法
Object.keys(globalCustom).forEach(key => {
    Vue.prototype[key] = globalCustom[key];
});

import state from './store/state';
import mutations from './store/mutations';
import actions from './store/actions';
const store = new Vuex.Store({
    modules: {},
    state,
    mutations,
    actions
});

Storage.checkExpire();
router.beforeEach((to, from, next) => {

    // 提前存入[针对于强制刷新时]
    let rp = state.currentRoutePath = to.path;
    let { dispatch, commit } = store;

    // 切换路由取消全部正在pending中api请求
    dispatch('cancelAjax');

    // 切换页面 失焦输入框 modal关闭状态 || 此时document文档dom未生成, 不能进行操作dom
    dispatch("blur");
    Modal.close();

    // 暴力关闭, 不单独做处理
    state.Toast && commit('Toast/close', {}, { root: true });
    state.Alert && commit('Alert/close', {}, { root: true });
    state.Loading && commit('Loading/close', {}, { root: true });

    // 统计时间
    if (to.meta.showTime) {
        if (typeof KnTJ !== 'undefined') {
            KnTJ.residenceTime(from.path, to.path, from.fullPath, to.fullPath);
        }
    }

    if (sessionStorage.getItem('type') === 'taxloan') return next()

    if (sessionStorage.getItem('type') === 'farmerloan') return next()

    if (to.meta.auth) {
        let oQuery = to.query;

        // 来源为 single
        if (oQuery.source === 'single') {
            return next();
        }

        // lpr流程入口判断
        if (to.meta.lprProcess) {
            return dispatch('lprSiteIndex', {
                hideLoading: state.hideLoading,
                handleBack: () => {
                    return dispatch('lprProcessComputed', {
                        toName: to.name,
                        register: to.meta.register,
                        handleBack(routeName) {
                            if (to.name === routeName) return next();

                            next({
                                name: routeName,
                                query: Object.assign(from.query, {
                                    source: 'lpr'
                                })
                            });
                        }
                    });
                }
            });
        }

        // {额度, 借款}两条流程总入口判断
        // 非正常流程ordinary走
        // if (to.meta.process && Number(oQuery.ordinary) !== 1) {
        //     return dispatch('siteIndex', {
        //         hideLoading: state.hideLoading,
        //         productId: sessionStorage.getItem('productId'),
        //         handleBack: (res) => {
        //             // 这里争对返回的project_code做一个判断，如果注册了其他产品，则自动跳转到已注册的产品首页，如果返回空，则不做任何跳转继续当前页。
        //             // 税银贷
        //             // if (!['user', 'planList', 'helper'].includes(to.name) && res.data.user_status !== 'active' && res.data.project_code == 'qn_syd') {
        //             //     next({
        //             //         name: 'tax-home',
        //             //         query: ''
        //             //     });
        //             //     return
        //             // }
        //             // 农户贷project_code: qn_nhd
        //             // if (!['user', 'planList', 'helper'].includes(to.name) && res.data.user_status !== 'active' && res.data.project_code === 'qn_nhd') {
        //             //     next({
        //             //         name: 'farmer-home',
        //             //         query: ''
        //             //     });
        //             //     return
        //             // }
        //             return dispatch('processComputed', {
        //                 toName: to.name,
        //                 register: to.meta.register,
        //                 handleBack(routeName) {
        //                     // 20200628系统升级-注册、进人脸前、还款判断
        //                     let inStop = false;
        //                     dispatch('serviceStopTips', {
        //                         handleBack(status) {
        //                             inStop = status;
        //                         }
        //                     });
        //                     console.log(inStop);
        //                     if (['quotaQuery', 'quotaQueryFaceidVerify', 'repaymentList', 'planList'].includes(routeName) && inStop) return next({
        //                         name: 'updating',
        //                         query: Object.assign(from.query, {
        //                             source: routeName
        //                         })
        //                     })

        //                     if (to.name === routeName) return next();

        //                     if (routeName === 'bindOuterCardII') return commit('Alert/show', {
        //                         text: '请开通他行卡二类户',
        //                         closeBtn: false,
        //                         callback: () => {
        //                             next({
        //                                 name: routeName,
        //                                 query: Object.assign(from.query, {
        //                                     source: 'home'
        //                                 })
        //                             });
        //                         }
        //                     });

        //                     // 20200603取消准入白名单需求-进人脸前判断是否允许进件，不允许给出提示，并返回首页
        //                     if (routeName === 'quotaQueryFaceidVerify' && !state.userInfo.apply_allow) return commit('Alert/show', {
        //                         text: '尊敬的客户您好，我行网贷系统业务申请人数已达当日峰值，请您明日再试。',
        //                         closeBtn: false,
        //                         callback: () => {
        //                             next({
        //                                 name: 'home',
        //                                 query: Object.assign(from.query, {
        //                                     source: 'quotaQueryFaceidVerify'
        //                                 })
        //                             });
        //                         }
        //                     });

        //                     next({
        //                         name: routeName,
        //                         query: Object.assign(from.query, {
        //                             source: 'home'
        //                         })
        //                     });
        //                 }
        //             });
        //         }
        //     });
        // }

        next();
    } else {
        next();
    }
});

new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
});

// let fn = (num) => {
//     return new Promise((resolve, reject) => {
//         return resolve(1 + num);
//     });
// };
// let kk = async () => {
//     let re = await fn(2);
//     let arr = [1,2,3]
//     let o = {a: 1, b:2}
//     let oo = Object.assign({}, o, {
//         a: 11
//     });
//     re = re + '|' + o.a + '|' + oo.a + '|' + arr.includes(2);
//     alert(re);
//     window.asyncRe = re;
// }
// kk();



// WEBPACK FOOTER //
// ./src/main.js